"use strict";

module.exports = function (column, row) {
  if (!this.opts.cellClasses[column]) return '';
  return this.opts.cellClasses[column].filter(function (item) {
    return item.condition(row);
  }).map(function (item) {
    return item["class"];
  }).join(' ');
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/cell-classes.js
// module id = lm4Y
// module chunks = 0